import { getV3dInstance } from './get-v3d-instance';

export const getV3dProcedures = () => getV3dInstance().puzzles.procedures;
